import { render, staticRenderFns } from "./syntask.vue?vue&type=template&id=712e7b31&scoped=true&"
import script from "./syntask.vue?vue&type=script&lang=js&"
export * from "./syntask.vue?vue&type=script&lang=js&"
import style0 from "./syntask.vue?vue&type=style&index=0&id=712e7b31&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712e7b31",
  null
  
)

export default component.exports